import { ca } from '@cian/analytics';

export const trackAboutDeveloperTagClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BuildingProgress_JK',
    pageType: 'BuildingProgressJK',
    action: 'tag_click',
    label: 'about_developer',
  });
};
